"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProtectedRoutes = exports.IsAdminAllow = exports.RedirectAuthRoute = exports.isAllowedUser = exports.isAdmin = void 0;
exports.isSuperAdmin = isSuperAdmin;
const react_1 = __importDefault(require("react"));
const react_router_dom_1 = require("react-router-dom");
const hook_1 = require("../../redux/hook");
function isSuperAdmin(user) {
    return user && user.status === "superadmin";
}
const isAdmin = (user) => {
    return ((user === null || user === void 0 ? void 0 : user.status) === "admin" ||
        (user === null || user === void 0 ? void 0 : user.status) === "superadmin" ||
        (user === null || user === void 0 ? void 0 : user.status) === "collaborator");
};
exports.isAdmin = isAdmin;
const isAllowedUser = (user) => {
    return user && (0, exports.isAdmin)(user);
};
exports.isAllowedUser = isAllowedUser;
const RedirectAuthRoute = ({ children }) => {
    const { token, user } = (0, hook_1.useAppSelector)((state) => state.user);
    const isAuthenticated = token && (user === null || user === void 0 ? void 0 : user.user_id);
    const isAllowed = (0, exports.isAllowedUser)(user);
    let path = "/";
    if (!isAuthenticated || !isAllowed) {
        return children;
    }
    if ((0, exports.isAdmin)(user)) {
        path = "/admin/tableau-de-bord";
    }
    return react_1.default.createElement(react_router_dom_1.Navigate, { to: path, replace: true });
};
exports.RedirectAuthRoute = RedirectAuthRoute;
const IsAdminAllow = ({ children, field, }) => {
    const { user } = (0, hook_1.useAppSelector)((state) => state.user);
    const is_SuperAdmin = (0, hook_1.useAppSelector)((s) => { var _a; return isSuperAdmin((_a = s.user) === null || _a === void 0 ? void 0 : _a.user); });
    const navigate = (0, react_router_dom_1.useNavigate)();
    if (!user[field] && !is_SuperAdmin) {
        setTimeout(() => {
            navigate(-1);
        }, 10);
    }
    return children;
};
exports.IsAdminAllow = IsAdminAllow;
const ProtectedRoutes = ({ children, userType, }) => {
    let location = (0, react_router_dom_1.useLocation)();
    const { user } = (0, hook_1.useAppSelector)((state) => state.user);
    const isAccess = userType === null || userType === void 0 ? void 0 : userType.includes(user === null || user === void 0 ? void 0 : user.status);
    const isAuthenticated = !!(user === null || user === void 0 ? void 0 : user.user_id);
    if (!isAuthenticated) {
        return react_1.default.createElement(react_router_dom_1.Navigate, { to: `/?redirectTo=${location === null || location === void 0 ? void 0 : location.pathname}`, state: { from: location }, replace: true });
    }
    if (!isAccess) {
        return react_1.default.createElement(react_router_dom_1.Navigate, { to: "/", replace: true });
    }
    return children;
};
exports.ProtectedRoutes = ProtectedRoutes;
